import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const VerticalStyled = styled.div`
    position: relative;
    z-index: 2;

    ${({ $top }) => {
        return css`
            transition: top ${$top.speed}ms ease ${$top.delay}ms;
            top: ${convertPxToRem($top.value)};
        `;
    }}
`;

// component
const Vertical = ({ children }) => {
    const {
        animation: {
            styleProps: { top }
        }
    } = useSiteHeader();
    return <VerticalStyled $top={top}>{children}</VerticalStyled>;
};

export default Vertical;

// prop-types
Vertical.propTypes = {
    children: PropTypes.any
};
